
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    open: null,
    severity: null,
    message: null,
}


export const SnakbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {

        openSnackBar(state, action) {
            console.log('action.payload', action.payload)
            state.open = true;
            state.severity = action.payload.severity;
            state.message = action.payload.message;
        },
        closeSnackBar(state) {

            state.open = false;
            state.message = null;
        },
    },


});

export default SnakbarSlice.reducer;
export const { closeSnackBar } = SnakbarSlice.actions;


export const showSnackbar =
    ({ severity, message }) =>
        async (dispatch, getState) => {

            dispatch(
                SnakbarSlice.actions.openSnackBar({
                    message,
                    severity,
                })
            );

            setTimeout(() => {
                dispatch(SnakbarSlice.actions.closeSnackBar());
            }, 4000);
        };
